import type { GetOrganization } from "@/server-types";

export type ProviderCapabilities = NonNullable<
  GetOrganization["response"]
>["capabilities"];

type CapabilityName = keyof ProviderCapabilities;

// Unknown keeps today's behaviour: the server still refuses what the vendor lacks.
export function hasCapability(
  capabilities: Partial<ProviderCapabilities> | null | undefined,
  name: CapabilityName,
): boolean {
  return capabilities?.[name] ?? true;
}

export function hasDocumentSettings(
  capabilities: Partial<ProviderCapabilities> | null | undefined,
): boolean {
  return (
    hasCapability(capabilities, "pdfAppearance") ||
    hasCapability(capabilities, "upn")
  );
}

// Only a vendor that registers premises with the tax authority needs the certificate first.
export function premiseStepPrerequisites(
  capabilities: Partial<ProviderCapabilities> | null | undefined,
): readonly ("info" | "cert")[] {
  return hasCapability(capabilities, "premiseRegistration")
    ? ["info", "cert"]
    : ["info"];
}
